import React, { useEffect, useState, useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { chakra, Flex, Button, Box, Container, Spacer } from '@chakra-ui/react';
import Logo from './Logo';
import CloseButton from './CloseButton';
import LocalisedLink from './LocalisedLink';
import NavDropDown from './NavDropDown';
import { LocaleContext } from './Layout';
import CtaLink from './CtaLink';

// TODO refactor for simplicity if possible

const NavigationBar = chakra(Container, {
  baseStyle: {
    display: 'flex',
    position: 'relative',
    zIndex: '9998',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
});

const MenuItems = chakra('ul', {
  baseStyle: {
    listStyle: 'none',
    alignItems: 'center',
    margin: '0',
    padding: '0',
    display: 'none',
    '@media only screen and (min-width: 1170px)': {
      display: 'flex',
      color: '#fff',
    },
  },
});

const MenuItem = chakra(LocalisedLink, {
  baseStyle: {
    color: '#fff !important',
  },
});

MenuItem.defaultProps = {
  display: ['block', 'block', 'inline-block'],
  p: [0, 0, 3],
};

const MenuItemA = chakra('a', {
  baseStyle: {},
});

MenuItemA.defaultProps = {
  display: ['block', 'inline-block'],
  p: [0, 0, 0],
};

MenuItem.defaultProps = {
  display: ['block', 'inline-block'],
  p: [0, 0, 3],
};

const ToggleLink = chakra(Button, {
  baseStyle: {
    background: 'none',
    border: 'none',
    display: 'block',
    '@media only screen and (min-width: 1170px)': {
      display: 'none',
    },
  },
});

const SubNavButton = chakra('li', {
  baseStyle: {
    flexGrow: '1',
    flexShrink: '1',
    margin: '0',
    // color: 'secondary',
    position: 'relative',
    _hover: {
      '.subnav-content': {
        clip: 'auto',
      },
    },
  },
});

SubNavButton.defaultProps = {
  p: ['8px 0', '8px 0', '0  0.6667rem'],
};

const MobNav = chakra('nav', {
  baseStyle: {
    position: 'fixed',
    top: '0',
    left: '0',
    backgroundColor: '#f2f9fb',
    height: '100vh',
    width: '100vw',
    padding: '16px 2rem',
    zIndex: '99999999999999999',
    textAlign: 'left',
    overflow: 'scroll',
    button: {
      marginBottom: '0.3rem',
    },
    '.primary': {
      color: '#f2f9fb',
    },
  },
});

const MobileMenuItems = chakra('ul', {
  baseStyle: {
    listStyle: 'none',
    textAlign: 'left',
    margin: '16px 0 0 0',
    padding: '0',
    a: {
      color: 'secondary',
      display: 'block',
      paddingBottom: '8px',
      textAlign: 'left',
    },
    _hover: {
      color: 'primary',
      textDecoration: 'none',
    },
  },
});

export type NavProps = {
  home?: boolean;
  nzHome?: boolean;
  auHome?: boolean;
};

/** Our main navigation component */
const Nav = ({ home, nzHome, auHome }: NavProps) => {
  const { locale: pageContextLocale } = useContext(LocaleContext);

  const [toggleMenu, setToggleMenu] = useState(false);
  const [locale, setLocale] = useState(pageContextLocale);

  useEffect(() => {
    setLocale(
      JSON.parse(window?.localStorage.getItem('browserLocation' || 'en'))
    );
  }, []);

  const data = useStaticQuery(graphql`
    query saferNavQuery {
      safetySuite: allDatoCmsFeaturePage(
        sort: { treeChildren: { position: ASC } }
        filter: {
          locale: { eq: "en" }
          id: { eq: "DatoCmsFeaturePage-30686713-en" }
          meta: { status: { in: ["updated", "published"] } }
        }
      ) {
        edges {
          node {
            title
            featureName
            id
            slug
            treeParent {
              id
              title
              slug
              featureName
            }
            treeChildren {
              id
              title
              slug
              position
              featureName
              treeParent {
                slug
              }
            }
          }
        }
      }
      NzSafetySuite: allDatoCmsFeaturePage(
        sort: { treeChildren: { position: ASC } }
        filter: {
          locale: { eq: "en-NZ" }
          id: { eq: "DatoCmsFeaturePage-30686713-en-NZ" }
          meta: { status: { in: ["updated", "published"] } }
        }
      ) {
        edges {
          node {
            title
            featureName
            id
            slug
            treeParent {
              id
              title
              slug
              featureName
            }
            treeChildren {
              id
              title
              slug
              position
              featureName
              treeParent {
                slug
              }
            }
          }
        }
      }
      AuSafetySuite: allDatoCmsFeaturePage(
        sort: { treeChildren: { position: ASC } }
        filter: {
          locale: { eq: "en-AU" }
          id: { eq: "DatoCmsFeaturePage-30686713-en-AU" }
          meta: { status: { in: ["updated", "published"] } }
        }
      ) {
        edges {
          node {
            title
            featureName
            id
            slug
            treeParent {
              id
              title
              slug
              featureName
            }
            treeChildren {
              id
              title
              slug
              position
              featureName
              treeParent {
                slug
              }
            }
          }
        }
      }
      virusFeatures: allDatoCmsFeaturePage(
        sort: { position: ASC }
        filter: {
          id: { eq: "DatoCmsFeaturePage-30686750-en" }
          meta: { status: { in: ["updated", "published"] } }
        }
      ) {
        edges {
          node {
            title
            featureName
            id
            slug
            meta {
              status
            }
            treeParent {
              id
              title
              slug
              featureName
            }
            treeChildren {
              id
              title
              slug
              position
              featureName
              treeParent {
                slug
              }
              meta {
                status
              }
            }
          }
        }
      }
      # PartnerWithUs: allDatoCmsFeaturePage(
      #   # sort: { treeChildren: { position: ASC }}
      #   filter: {
      #     locale: { eq: "en-NZ" }
      #     id: { eq: "DatoCmsFeaturePage-30686721-en-NZ" }
      #     # meta: { status: { in: ["updated", "published"] } }
      #   }
      # ) {
      #   edges {
      #     node {
      #       title
      #       featureName
      #       id
      #       slug
      #       treeParent {
      #         id
      #         title
      #         slug
      #         featureName
      #       }
      #       treeChildren {
      #         id
      #         title
      #         slug
      #         position
      #         featureName
      #         treeParent {
      #           slug
      #         }
      #       }
      #     }
      #   }
      # }
      # AUPartnerWithUs: allDatoCmsFeaturePage(
      #   sort: { treeChildren: { position: ASC }}
      #   filter: {
      #     locale: { eq: "en-AU" }
      #     id: { eq: "DatoCmsFeaturePage-30686721-en-AU" }
      #     meta: { status: { in: ["updated", "published"] } }
      #   }
      # ) {
      #   edges {
      #     node {
      #       title
      #       featureName
      #       id
      #       slug
      #       treeParent {
      #         id
      #         title
      #         slug
      #         featureName
      #       }
      #       treeChildren {
      #         id
      #         title
      #         slug
      #         position
      #         featureName
      #         treeParent {
      #           slug
      #         }
      #       }
      #     }
      #   }
      # }
    }
  `);

  const dynamicMenuLinks = (location, locale) => {
    if (locale === 'en-NZ') {
      return (
        <>
          <SubNavButton>
            <NavDropDown
              buttonName="Software"
              data={data.NzSafetySuite}
              home={home}
              location={location}
            />
          </SubNavButton>
          <SubNavButton>
            <NavDropDown
              buttonName="Partner with us"
              home={home}
              manualData={[
                {
                  id: 'whyPartnerWithSaferMe',
                  slug: '/en-nz/health-and-safety-consultants/',
                  featureName: 'Why Partner with SaferMe',
                },
                {
                  id: 'health-and-safety-consultant',
                  slug: '/health-safety-consultant',
                  featureName: 'Find a Safety Consultant',
                },
              ]}
            />
          </SubNavButton>
          <SubNavButton>
            <NavDropDown
              buttonName="Resources"
              manualData={[
                {
                  id: 'resources',
                  slug: '/resources',
                  featureName: 'Research, Case Studies and Guides',
                },
                {
                  id: 'pricingPlan',
                  slug: '/pricing',
                  featureName: 'Pricing',
                },
                { id: 'blog', slug: '/blog', featureName: 'Blog' },
                {
                  id: 'innovation',
                  slug: '/acc-personal-worker-safety-innovation-project',
                  featureName: 'ACC Innovation Project',
                },
                {
                  id: 'help',
                  slug: 'https://help.safer.me/knowledge',
                  featureName: 'Help Centre',
                },
                {
                  id: 'aboutUs',
                  slug: '/about-us',
                  featureName: 'About Us',
                },
                {
                  id: 'contactUs',
                  slug: '/info/contact-us',
                  featureName: 'Contact Us',
                },
              ]}
              home={home}
              location={location}
            />
          </SubNavButton>
        </>
      );
    }
    if (locale === 'en-AU') {
      return (
        <>
          <SubNavButton>
            <NavDropDown
              buttonName="Software"
              data={data.AuSafetySuite}
              home={home}
              location={location}
            />
          </SubNavButton>
          <SubNavButton>
            <NavDropDown
              buttonName="Partner with us"
              home={home}
              manualData={[
                {
                  id: 'whyPartnerWithSaferMe',
                  slug: '/health-and-safety-consultants/',
                  featureName: 'Why Partner with SaferMe',
                },
              ]}
            />
          </SubNavButton>
          <SubNavButton>
            <NavDropDown
              buttonName="Resources"
              manualData={[
                {
                  id: 'resources',
                  slug: '/resources',
                  featureName: 'Research, Case Studies and Guides',
                },
                {
                  id: 'pricingPlan',
                  slug: '/pricing',
                  featureName: 'Pricing',
                },
                {
                  id: 'innovation',
                  slug: '/acc-personal-worker-safety-innovation-project',
                  featureName: 'Innovation Project',
                },
                {
                  id: 'health-and-safety-consultants',
                  slug: '/health-and-safety-consultants',
                  featureName: 'Become a Partner',
                },
                { id: 'blog', slug: '/blog', featureName: 'Blog' },
                {
                  id: 'help',
                  slug: 'https://help.safer.me/knowledge',
                  featureName: 'Help Centre',
                },
                {
                  id: 'aboutUs',
                  slug: '/about-us',
                  featureName: 'About Us',
                },
                {
                  id: 'contactUs',
                  slug: '/info/contact-us',
                  featureName: 'Contact Us',
                },
              ]}
              home={home}
              location={location}
            />
          </SubNavButton>
        </>
      );
    }
    return (
      <>
        <SubNavButton>
          <NavDropDown
            buttonName="Virus Management"
            data={data.virusFeatures}
            home={home}
            location={location}
          />
        </SubNavButton>
        <SubNavButton>
          <NavDropDown
            buttonName="Safety Suite"
            data={data.safetySuite}
            home={home}
            location={location}
          />
        </SubNavButton>
        <SubNavButton>
          <NavDropDown
            buttonName="Resources"
            manualData={[
              {
                id: 'resources',
                slug: '/resources',
                featureName: 'Research, Case Studies and Guides',
                __typename: 'manual',
              },
              {
                id: 'pricingPlan',
                slug: '/pricing',
                featureName: 'Pricing',
              },
              {
                id: 'innovation',
                slug: '/acc-personal-worker-safety-innovation-project',
                featureName: 'Innovation Project',
              },
              {
                id: 'health-and-safety-consultants',
                slug: '/health-and-safety-consultants',
                featureName: 'Become a Partner',
                __typename: 'manual',
              },
              { id: 'blog', slug: '/blog', featureName: 'Blog' },
              {
                id: 'help',
                slug: 'https://help.safer.me/knowledge',
                featureName: 'Help Center',
                __typename: 'manual',
              },
              {
                id: 'aboutUs',
                slug: '/about-us',
                featureName: 'About Us',
              },
              {
                id: 'contactUs',
                slug: '/info/contact-us',
                featureName: 'Contact Us',
              },
            ]}
            home={home}
            location={location}
          />
        </SubNavButton>
      </>
    );
  };

  let homePage: string;
  if (locale === 'en-NZ' || locale === 'en-AU') {
    homePage = '/';
  } else {
    homePage = '../';
  }

  const MobMenu = ({ toggle }) => (
    <MobNav>
      <button
        type="button"
        onClick={toggle}
        style={{
          position: 'absolute',
          top: 30,
          right: 15,
          padding: 15,
          background: 'transparent',
          border: 0,
        }}
      >
        <CloseButton />
      </button>

      <Box my={[2, 0]} maxWidth="116px">
        <LocalisedLink to={homePage} aria-label="SaferMe Home">
          <Logo width="116px" />
        </LocalisedLink>
      </Box>
      <MobileMenuItems>
        {dynamicMenuLinks('mobile', locale || pageContextLocale)}
        <SubNavButton>
          <CtaLink
            link={null}
            variant={home || nzHome || auHome ? 'primaryDark' : 'primary'}
          />
        </SubNavButton>
      </MobileMenuItems>
    </MobNav>
  );

  return (
    <>
      {toggleMenu && <MobMenu toggle={() => setToggleMenu(false)} />}
      <NavigationBar
        as="nav"
        variant="nav"
        margin="auto"
        flexBasis="1110px"
        mt={1}
        alignItems={['center', 'flex-start']}
      >
        <LocalisedLink to={homePage}>
          <Box maxWidth={[116, 232]}>
            <Logo white={home} />
          </Box>
        </LocalisedLink>
        <Spacer />
        <MenuItems p={2}>
          {dynamicMenuLinks('', locale || pageContextLocale)}
          <SubNavButton style={{ paddingRight: 0 }}>
            <CtaLink
              link={null}
              variant={home || nzHome || auHome ? 'primaryDark' : 'primary'}
            />
          </SubNavButton>
        </MenuItems>

        <ToggleLink
          onClick={() => setToggleMenu(!toggleMenu)}
          p={0}
          aria-expanded={toggleMenu ? 'true' : 'false'}
          aria-controls="menu-list"
          className="nav-toggle"
        >
          <Flex flexDirection="row" justify="center">
            <span style={{ fontSize: '.8rem' }}>Menu</span>
            <svg
              height="24px"
              id="Menu"
              style={{ marginLeft: '5px' }}
              version="1.1"
              viewBox="0 0 32 32"
              width="32px"
            >
              <path
                style={{ fill: home ? '#fff' : ' #333' }}
                d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
              />
            </svg>
          </Flex>
        </ToggleLink>
      </NavigationBar>
    </>
  );
};

export default Nav;
